<template>
  <div class="function-card-container">
    <Upload v-if="active==='upload'" />
    <Handle v-else-if="active==='handle'" />
    <Project v-else-if="active==='project'" />
  </div>
</template>

<script>
import Upload from './upload.vue';
import Handle from './handle.vue';
import Project from './project.vue'
export default {
  components: {
    Upload,
    Handle,
    Project
  },
  props: {
    active: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
.function-card-container {
  height: 100%;
}
</style>